export const FORMS_ENGINE_FORM_RESOURCE = {
  key: 'FORMS_ENGINE_FORM_RESOURCE'
};
